import React from 'react';
import styles from './ReadingStats.module.scss';
import { useQuery } from '@apollo/react-hooks';
import { READING_STATS_SCHOOL, READING_STATS_CLASS } from './services/graphql';
import { Loader } from '@squirrellearningltd/go-teacher-components';

const ReadingStatsMinimal = () => {
    const {
        data: schoolReadingStats,
        loading: schoolReadingLoading,
        error: schoolReadingError,
    } = useQuery(READING_STATS_SCHOOL, {
        variables: {
            itemsCounter: 3,
            startFrom: '01/01/2026',
            endOn: '31/12/2026',
        },
    });

    const {
        data: classReadingStats,
        loading: classReadingLoading,
        error: classReadingError,
    } = useQuery(READING_STATS_CLASS, {
        variables: {
            itemsCounter: 3,
            startFrom: '01/01/2026',
            endOn: '31/12/2026',
        },
    });

    return (
        <div className={styles.nyorWrap}>
            <div className={styles.nyorHeader}>
                <h2 className={styles.HeaderHeadline}>National Reading Leaderboard 🏆</h2>
                <p className={styles.HeaderParagraph}>Celebrating our top classes and schools</p>
            </div>

            <div className={styles.nyorGrid}>
                <div className={styles.nyorCard}>

                    <h3 className={styles.CardHeadline}>🏫 Top 3 Schools</h3>

                    {schoolReadingLoading &&
                        <div className={styles.loaderContainer}>
                            <Loader />
                        </div>
                    }

                    {schoolReadingError &&
                        <p className={styles.pageText}>
                            Data could not be loaded. Please try again later.
                        </p>
                    }

                    {schoolReadingStats &&
                        schoolReadingStats.readathonOverallStats &&
                        schoolReadingStats.readathonOverallStats.length ? (
                        <div className={styles.nyorList}>
                            {schoolReadingStats.readathonOverallStats.map(
                                (stat, index) => {
                                    return (
                                        <div key={index} className={styles.nyorItem}>
                                            <div className={`${styles.nyorRank}  ${styles[`rank${index + 1}`]}`} aria-label={`${index + 1} place`}>{index === 0 ? '🥇' : index === 1 ? '🥈' : '🥉'} </div>
                                            <div className={styles.nyorMeta}>
                                                <div className={styles.nyorName}>{stat.schoolName}</div>
                                                <div className={styles.nyorSub}>{index === 0 ? 'Top performing school' : index === 1 ? 'Fantastic reading effort' : 'Great reading progress'} </div>
                                            </div>

                                            <div className={styles.dataRowScore}>
                                                <div
                                                    className={
                                                        styles.dataRowScoreNumber
                                                    }
                                                >
                                                    {stat.score}
                                                </div>
                                                <div
                                                    className={styles.dataRowScoreLabel}
                                                >
                                                    avg logs
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            )}
                        </div>) : <p>No data available</p>}

                </div>

                <div className={styles.nyorCard}>
                    <h3 className={styles.CardHeadline}>📚 Top 3 Classes</h3>
                    {classReadingLoading &&
                        <div className={styles.loaderContainer}>
                            <Loader />
                        </div>
                    }

                    {classReadingError &&
                        <p className={styles.pageText}>
                            Data could not be loaded. Please try again later.
                        </p>
                    }

                    <div className={styles.nyorList}>
                        {classReadingStats &&
                            classReadingStats.readathonStudentsClassOverallStats &&
                            classReadingStats.readathonStudentsClassOverallStats.length ? (
                            <div className={styles.nyorList}>
                                {classReadingStats.readathonStudentsClassOverallStats.map(
                                    (stat, index) => {
                                        return (
                                            <div key={index} className={styles.nyorItem}>
                                                <div className={`${styles.nyorRank}  ${styles[`rank${index + 1}`]}`} aria-label={`${index + 1} place`}>{index === 0 ? '🥇' : index === 1 ? '🥈' : '🥉'} </div>
                                                <div className={styles.nyorMeta}>
                                                    <div className={styles.nyorName}>{stat.studentsClassName}</div>
                                                    <div className={styles.nyorSub}>{stat.studentsClass.school.name} </div>
                                                </div>


                                                <div className={styles.dataRowScore}>
                                                    <div
                                                        className={
                                                            styles.dataRowScoreNumber
                                                        }
                                                    >
                                                        {stat.totalLogs}
                                                    </div>
                                                    <div
                                                        className={styles.dataRowScoreLabel}
                                                    >
                                                        avg logs
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                )}
                            </div>) : <p>No data available</p>}
                    </div>
                </div>
            </div>

            <div className={styles.nyorFoot}>
                <span className={styles.nyorPulse}>
                    <span className={styles.nyorDot}></span>
                    Updated from the National Reading Leaderboard
                </span>
            </div>
        </div>
    )
}

export default ReadingStatsMinimal;